import { BookingError } from 'config/datadog';

export default function getError(response: any, errorCode: BookingError) {
  // Check response.errors first (for mutation responses)
  if (response?.errors) {
    const error = response.errors.find(
      (item: any) => item.extensions?.code === errorCode
    );
    if (error) return error;
  }

  // Also check graphQLErrors (for ApolloError from queries)
  if (response?.graphQLErrors) {
    return response.graphQLErrors.find(
      (item: any) => item.extensions?.code === errorCode
    );
  }
}
